import {BasePageData} from '../models/strapi/base-page-data';
import {StrapiButtonProps} from '../models/strapi/strapi-button-props';
import {StrapiHeadline} from '../models/strapi/strapi-headline';
import {StrapiMeta} from '../models/strapi/strapi-meta';
import {StrapiStage} from '../models/strapi/strapi-stage';
import {StrapiTextFieldProps} from '../models/strapi/strapi-text-field-props';
import {useLanguageDependentDataSSr} from './useLanguageDependentDataSsr.hook';

export const useMarketplacePage =
    useLanguageDependentDataSSr<UseMarketplacePageData>('marketplace-page');

interface UseMarketplacePageData extends BasePageData{
    stage: StrapiStage;
    filterHeadline: StrapiHeadline;
    productType: StrapiTextFieldProps;
    genre: StrapiTextFieldProps;
    originator: StrapiTextFieldProps;
    sortBy: StrapiTextFieldProps;
    initialSale: string;
    resale: string;
    sortByLowestPrice: string;
    sortByHighestPrice: string;
    sortByAlphabetAsc: string;
    sortByAlphabetDesc: string;
    applyFilter: StrapiButtonProps;
    noItemsWithFilter: string;
    meta: StrapiMeta;
}
